
import APIClient from './APIClient'

class CTrackerAPI {

  async getActiveEntry() {
    const res = await APIClient.GET('/tracker')
    return res
  }

  async clockOn({ time, lat, lng }) {
    const res = await APIClient.POST('/tracker/on', { time, lat, lng })
    return res
  }

  // { time, lat, lng, break }
  async clockOff(params) {
    const res = await APIClient.POST('/tracker/off', params)
    return res
  }

  async update(p) {
    const q = {}
    if (typeof p.truck_overnight === 'boolean') q.truck_overnight = p.truck_overnight
    if (typeof p.washing === 'boolean') q.washing = p.washing
    if (!isNaN(p.break)) q.break = p.break
    const res = await APIClient.POST('/tracker', q)
    return res
  }

  async sync(actions) {
    const res = await APIClient.POST('/tracker/sync', { actions })
    return res
  }

}

const TrackerAPI = new CTrackerAPI()

export default TrackerAPI



// WEBPACK FOOTER //
// ./src/api/TrackerAPI.js